module.exports = __webpack_public_path__ + "static/media/human4.30c63064.jpg";